import { Menu, rem } from "@mantine/core"
import {
  IconBooks,
  IconMail,
  IconMessageCircle,
  IconScript,
} from "@tabler/icons-react"

import { NavbarButtonWithMenu } from "@/components/generic/SideNavBar/components/NavbarButtonWithMenu"
import { useRouter } from "next-nprogress-bar"
import { useAppStore } from "@/app/(store)/appStore"
import Link from "next/link"

interface NavbarTemplatesButtonProps {
  isSelected: boolean
  isSidebarMenuExpanded: boolean
}

export function NavbarTemplatesButton({
  isSelected,
  isSidebarMenuExpanded,
}: NavbarTemplatesButtonProps) {
  const router = useRouter()
  const changeSidebarMenuState = useAppStore(
    (state) => state.changeSidebarMenuState
  )

  function handleClick(href: string) {
    changeSidebarMenuState(false)
    router.push(href)
  }

  return (
    <NavbarButtonWithMenu
      icon={IconBooks}
      isSelected={isSelected}
      isSidebarMenuExpanded={isSidebarMenuExpanded}
    >
      <Menu.Dropdown miw={200}>
        {/* <Menu.Label>Application</Menu.Label> */}
        <Menu.Item
          leftSection={<IconMail style={{ width: rem(14), height: rem(14) }} />}
          component={Link}
          href="/templates/email/library"
        >
          Email Templates
        </Menu.Item>
        <Menu.Item
          component={Link}
          href="/templates/sms/library"
          leftSection={
            <IconMessageCircle style={{ width: rem(14), height: rem(14) }} />
          }
          // onClick={() => handleClick("/templates/sms/library")}
        >
          SMS / MMS Templates
        </Menu.Item>
        <Menu.Item
          component={Link}
          href="/call/scripts"
          leftSection={
            <IconScript style={{ width: rem(14), height: rem(14) }} />
          }
          // onClick={() => handleClick("/call/scripts")}
        >
          Call Scripts
        </Menu.Item>
      </Menu.Dropdown>
    </NavbarButtonWithMenu>
  )
}
